
import { useState } from "react"
import { ExternalLink, Github, Filter } from "lucide-react"
import "../styles/Projects.css"

const Projects = () => {
  const allTags = [
    "Fullstack",
    "Frontend",
    "Backend",
    "C++",
    "C",
    "Python",
    "JavScript",
    "Golang",
    "Systems",
    "WASM",
    "Comp. Arch",
    "Web/Networking",
    "OS",
    "AI/ML",
    "React",
    "Node.js",
    "Django",
    "SQL",
    "NoSQL",
  ]
  const [selectedTags, setSelectedTags] = useState([])

  const projects = [
    {
      id: 1,
      title: "Instagram Clone",
      description:
        "A fullstack Instagram clone with user accounts, posting, comments, and follows, built using Python, SQL, and React, and deployed on AWS.",
      tags: ["Fullstack", "Frontend", "Backend", "React", "Python", "Node.js", "Flask", "JavaScript", "SQL", "AWS", "Web/Networking"],
      image: "project_pics/insta-demo-pic.jpg",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Instagram%20Clone/INFO.md",
      demo: "https://github.com/yousefbh1/Project_Demos/blob/main/Instagram%20Clone/Demo%20Video.md",
    },
    {
      id: 2,
      title: "C++ Thread Library",
      description: "A custom thread management library for C++ that provides comprehensive threading, mutual exlcusion and conditional variable capabilities.",
      tags: ["C++", "Systems", "OS", "Comp. Arch", "Backend"],
      image: "project_pics/thread_lib_pic.jpg",
      demo: "https://github.com/yousefbh1/Project_Demos/blob/main/Thread%20Library/Demo%20Video.md",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Thread%20Library/INFO.md",
    },
    {
      id: 3,
      title: "Search Engine",
      description: "A scalable search engine built with Python, SQL, React, and Hadoop that uses a MapReduce pipeline and tf-idf with adjustable PageRank to index and rank hundreds of gigabytes of data in under a second.",
      tags: ["Fullstack", "Backend", "Python", "SQL", "React", "JavaScript", "Web/Networking", "AI/ML", "NoSQL"],
      image: "project_pics/search_eng_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Search%20Engine/INFO.md",
      demo: "https://github.com/yousefbh1/Project_Demos/blob/main/Search%20Engine/Video.md",
    },
    {
      id: 4,
      title: "Portfolio Website",
      description: "A responsive portfolio website built with React and CSS.",
      tags: ["Frontend", "React", "CSS", "JavaScript", "SQLlite"],
      image: "project_pics/portfolio_site_pic.png",
      github: "https://github.com",
      demo: "https://example.com",
    },
    {
      id: 7,
      title: "AI Connect 4 Opponent",
      description: "A Python-based Connect Four game where the player faces an AI opponent. The AI utilizes a minimax algorithm with alpha‑beta pruning to determine optimal moves, resulting in a nearly unbeatable opponent. Built with Pygame for the game interface and NumPy for efficient computations.",
      tags: ["Python", "AI/ML"],
      image: "project_pics/connect_4_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/AI%20Connect%204%20Opponent/INFO.md",
      demo: "https://github.com/user-attachments/assets/27d597ca-ade1-44df-ba7e-ff8ffd4e0f56"
    },
    {
      id: 8,
      title: "Assembler",
      description: "A two-pass assembler for the 16-bit LC-2K architecture, written in C. It translates LC-2K assembly language into binary machine code and generates the necessary symbol and relocation information for linking.",
      tags: ["C", "Comp. Arch"],
      image: "project_pics/assembler_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Assembler/INFO.md",
      demo: "https://github.com/user-attachments/assets/ac8ee012-fc86-42f3-9750-8b7a70c51151"
    },
    {
      id: 9,
      title: "Cache Simulator",
      description: "A fully associative cache simulator for a 16-bit LC-2K CPU, implemented in C. It models realistic cache behavior including memory block management, a Least Recently Used (LRU) eviction policy, write-back handling of dirty blocks, and interaction with main memory on cache misses. The simulator provides insight into how a processor’s cache hierarchy improves performance by reducing memory access latency and optimizing access patterns.",
      tags: ["C", "Comp. Arch"],
      image: "project_pics/cache_simulator_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Cache%20Simulator/INFO.md",
      demo: "https://github.com/user-attachments/assets/324ce6e2-cd3e-443d-828f-44bf29a3ad96"
    },
    {
      id: 10,
      title: "Pathfinder",
      description: "A C++ command-line solver for graph optimization problems, focusing on computing MSTs and TSP tours for a set of 2D points. It can produce a Minimum Spanning Tree using Prim’s algorithm, find an approximate Traveling Salesman path using a greedy nearest-neighbor algorithm enhanced by 2-opt optimization (FASTTSP), or compute an exact optimal TSP route via branch-and-bound with MST-based pruning (OPTTSP). The program reads points from input and runs in the specified mode to output the solution.",
      tags: ["C++"],
      image: "project_pics/pathfinder_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Pathfinder/INFO.md",
      demo: "https://github.com/user-attachments/assets/00fead67-8df0-424b-b9f5-fc231bdaeb14"
    },
    {
      id: 11,
      title: "Processor Simulator",
      description: "A pipeline-level simulator for the LC-2K processor, implemented in C++. It reads a program’s instructions and data from a text file and simulates the CPU’s execution cycle by cycle. The simulator supports all LC-2K instructions and prints the state at each cycle (including the program counter, register contents, pipeline register states, and memory contents), providing a detailed view of how instructions progress through a pipelined processor and how hazards or pipeline stages affect execution.",
      tags: ["C++", "Comp. Arch"],
      image: "project_pics/processor_simulator_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Processor%20Simulator/INFO.md",
      demo: "https://github.com/user-attachments/assets/29e3eb4b-b4bf-4f9a-9580-e4e4edc983d4"
    },
    {
      id: 12,
      title: "Virtual Memory Pager",
      description: "A C++ simulation of an operating system’s virtual memory manager (pager). It handles virtual-to-physical memory translation for multiple processes, implementing demand paging and a clock-sweep page replacement algorithm.",
      tags: ["C++", "OS", "Systems"],
      image: "project_pics/virtual_pager_pic.png",
      github: "https://github.com/yousefbh1/Project_Demos/blob/main/Virtual%20Memory%20Pager/INFO.md",
      demo: "https://github.com/user-attachments/assets/62753ee0-58f5-4874-95de-4e2b8e10a385"
    },

    {
      id: 13,
      title: "Social Media API",
      description: "A RESTful API facilitating the interaction between a client front-end and SQL backend",
      tags: ["Python", "Backend", "Node.js", "Flask", "SQL"],
      image: "placeholder.svg?height=200&width=400",
      github: "https://github.com",
      demo: null,
    },
    {
      id: 14,
      title: "Real-time Chat Application",
      description: "A real-time chat application built using SpacetimeDB.",
      tags: ["Fullstack", "C#", "NoSQL"],
      image: "placeholder.svg?height=200&width=400",
      github: "https://github.com",
      demo: "https://example.com",
    },
  ]

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag))
    } else {
      setSelectedTags([...selectedTags, tag])
    }
  }

  const clearTags = () => {
    setSelectedTags([])
  }

  const filteredProjects =
    selectedTags.length === 0
      ? projects
      : projects.filter((project) => selectedTags.some((tag) => project.tags.includes(tag)))

  return (
    <div className="projects-container">
      <h1 className="section-title">Projects</h1>

      <div className="filter-container">
        <div className="filter-header">
          <div className="filter-title">
            <Filter size={18} />
            <span>Filter by tags</span>
          </div>
          {selectedTags.length > 0 && (
            <button className="clear-filters" onClick={clearTags}>
              Clear filters
            </button>
          )}
        </div>
        <div className="tags-container">
          {allTags.map((tag) => (
            <button
              key={tag}
              className={`tag-filter ${selectedTags.includes(tag) ? "active" : ""}`}
              onClick={() => toggleTag(tag)}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      <div className="projects-grid">
        {filteredProjects.map((project) => (
          <div key={project.id} className="project-card card">
            <div className="project-image">
              <img src={project.image || "/placeholder.svg"} alt={project.title} />
            </div>
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tags">
                {project.tags.map((tag) => (
                  <span key={tag} className="tag">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="project-links">
                <a href={project.github} className="project-link" target="_blank" rel="noopener noreferrer">
                  <Github size={16} /> Source
                </a>
                {project.demo && (
                  <a href={project.demo} className="project-link" target="_blank" rel="noopener noreferrer">
                    <ExternalLink size={16} /> Demo
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredProjects.length === 0 && (
        <div className="no-projects">
          <p>No projects match the selected filters. Try selecting different tags or clear the filters.</p>
        </div>
      )}
    </div>
  )
}

export default Projects
